var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorfulBracketLogo = function SvgColorfulBracketLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#colorful_bracket_logo_svg__a)",
    d: "M10.474 79.68q5.72 0 9.259-1.32t5.12-3.91q1.581-2.6 1.579-6.506V52.202q0-4.761 2.176-6.801T36 43.371v-6.975q-5.204 0-7.38-2.04-2.175-2.04-2.175-6.804V11.736q0-3.91-1.58-6.506t-5.12-3.91Q16.2 0 10.488 0v6.647q4.353 0 6.187 1.285t1.837 3.996v16.886q0 4.498 2.344 7.229t6.953 3.826q-4.603 1.02-6.953 3.742T18.51 50.84v16.92q0 2.722-1.837 3.997-1.839 1.275-6.187 1.285z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#colorful_bracket_logo_svg__b)",
    d: "M5.036 31.789c-3.268-.53-5.488-3.599-4.958-6.856.53-3.258 3.611-5.47 6.88-4.941s5.488 3.598 4.958 6.856-3.61 5.47-6.88 4.94"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "colorful_bracket_logo_svg__a",
    x1: 30.356,
    x2: -10.406,
    y1: 171.134,
    y2: 168.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "colorful_bracket_logo_svg__b",
    x1: 30.356,
    x2: -10.406,
    y1: 171.134,
    y2: 168.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05DF54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#96C5F0"
  })))));
};
export default SvgColorfulBracketLogo;